import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { signalStoreFeature, withMethods, withProps } from '@ngrx/signals';

import { OpenDialogState } from '../../types';

const _openDialog = (dialogData: OpenDialogState, matDialog: MatDialog) => {
  return matDialog.open(dialogData.component(), {
    autoFocus: dialogData.config?.autoFocus,
    data: dialogData.componentData,
    width: dialogData.config?.width,
    disableClose: dialogData.config?.disableClose ?? false,
  });
};

export const withDialogFeatures = () => {
  return signalStoreFeature(
    withProps(() => ({
      _matDialog: inject(MatDialog),
    })),
    withMethods(({ _matDialog }) => {
      return {
        openDialog: (payload: OpenDialogState) =>
          _openDialog(payload, _matDialog),
      };
    }),
  );
};
